import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { UserService } from './shared/services/user.service';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
 
  constructor(
    private permissionsService: NgxPermissionsService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageMap,
    private userService: UserService,
    private rs: NgxRolesService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    const currentVersion = '1.0.0';
    const cachedVersion = localStorage.getItem('app-version');
    
    if (cachedVersion !== currentVersion) {
      this.storage.clear().subscribe(() => {
        sessionStorage.clear();
        localStorage.setItem('app-version', currentVersion);
        
        if (cachedVersion) {
          window.location.reload();
          return;
        }
      });
      return;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const refreshToken = urlParams.get('refresh_token');
    const code = urlParams.get('code');
    const thaidError = urlParams.get('error');

    if (token && refreshToken) {
      this.processThaiIdLogin(token, refreshToken);
    } else if (code) {
      // ตั้ง flag (sync) ว่ากำลังประมวลผล ThaiD callback อยู่ — กัน signinv2/guard ล้าง token ระหว่างแลก code
      try { sessionStorage.setItem('thaid_cb_ts', Date.now().toString()); } catch (e) {}
      this.processThaiIdCode(code);
    } else if (thaidError) {
      this.router.navigate(['/sessions/signinv2'], { queryParams: { error: thaidError } });
    }
  }

    // ngOnInit(): void {
    //   // ดักจับ token จาก URL
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const token = urlParams.get('token');
    //   const refreshToken = urlParams.get('refresh_token');
      
    //   if (token && refreshToken) {
    //     this.processThaiIdLogin(token, refreshToken);
    //   }
    // }

  // ThaiD callback: แลก code -> token แล้วเข้าสู่ระบบ (มาจาก /auth/thaiid/callback?code=)
  private processThaiIdCode(code: string) {
    // กัน sendcode ซ้ำ (code ใช้ได้ครั้งเดียว เลี่ยง error 429)
    const processedKey = 'oauth_processed_' + code;
    if (localStorage.getItem(processedKey)) {
      return;
    }
    localStorage.setItem(processedKey, Date.now().toString());

    // ล้าง ?code= ออกจาก URL กัน reprocess ตอน reload
    try {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    } catch (e) {}

    this.auth.sendThaidCode(code).subscribe(
      (res: any) => {
        if (res && res.status === true && res.token) {
          this.processThaiIdLogin(res.token, res.refresh_token);
        } else {
          const msg = (res && (res.error || res.message)) || 'ไม่สามารถเข้าสู่ระบบด้วย ThaiID';
          try { sessionStorage.removeItem('thaid_cb_ts'); } catch (e) {}
          this.router.navigate(['/sessions/signinv2'], { queryParams: { error: msg } });
        }
      },
      () => {
        try { sessionStorage.removeItem('thaid_cb_ts'); } catch (e) {}
        this.router.navigate(['/sessions/signinv2'], { queryParams: { error: 'เกิดข้อผิดพลาดในการยืนยันตัวตน' } });
      }
    );
  }

  private processThaiIdLogin(token: string, refreshToken: string) {
    this.storage.clear().subscribe(() => {
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("accessToken", token);
      this.storage.set('token', token).subscribe(() => {
        this.userService.getUserInfo().subscribe((data) => {
          if (data) {
            this.userService.loadLogin().then((loginData: any) => {
              if (loginData != false) {
                this.permissionsService.loadPermissions(loginData.perm);
                this.rs.addRole(loginData.name, loginData.perm);
                this.storage.set('user', loginData).subscribe(() => {
                  try { sessionStorage.removeItem('thaid_cb_ts'); } catch (e) {}
                  this.router.navigate(['/'], { replaceUrl: true });
                });
              }
            });
          }
        });
      });
    });
  }
}